import { Title } from "./components/title/title";
import { Base } from "./header.base";

export const Header = Object.assign(Base, {
    Title: Title
});
